module.exports = __webpack_public_path__ + "static/media/trailer.0314551a.svg";